import axiosClient from './axiosClient';

export const getBorrowers = () => axiosClient.get('/api/borrowers');

export const createBorrower = (payload) => axiosClient.post('/api/borrowers', payload);

export const updateBorrower = (id, payload) => axiosClient.put(`/api/borrowers/${id}`, payload);

export const deleteBorrower = (id) => axiosClient.delete(`/api/borrowers/${id}`);
